import { z } from "zod";
import { IdSchema, IsoDateTimeSchema } from "./common.js";
import { APPROVAL_DECISIONS, APPROVAL_KINDS } from "../constants/index.js";

/**
 * 진실의 원천: harness/API-SPEC.md §4, harness/APPROVAL-POLICY.md
 */

export const ApprovalSchema = z.object({
  id: IdSchema,
  case_id: IdSchema,
  kind: z.enum(APPROVAL_KINDS),
  decision: z.enum(APPROVAL_DECISIONS),
  decided_at: IsoDateTimeSchema.nullable(),
  decided_by: IdSchema.nullable(),
  decision_note: z.string().nullable(),
  batch_id: z.string().nullable(),
});
export type Approval = z.infer<typeof ApprovalSchema>;

export const ApprovalCreateRequestSchema = z.object({
  case_ids: z.array(IdSchema).min(1),
  kind: z.enum(APPROVAL_KINDS),
});
export type ApprovalCreateRequest = z.infer<typeof ApprovalCreateRequestSchema>;

// 일괄 승인 — 체크박스 다중 선택 → 버튼 한 번 (harness/APPROVAL-POLICY.md §4)
export const ApprovalDecideRequestSchema = z
  .object({
    approval_ids: z.array(IdSchema).min(1).optional(),
    batch_id: z.string().optional(),
    decision: z.enum(["APPROVED", "REJECTED"]),
    decision_note: z.string().optional(),
  })
  .refine((v) => Boolean(v.approval_ids?.length) || Boolean(v.batch_id), {
    message: "approval_ids 또는 batch_id 중 하나는 있어야 한다",
  });
export type ApprovalDecideRequest = z.infer<typeof ApprovalDecideRequestSchema>;

/**
 * 한 케이스의 승인 목록. 출고 화면이 **승인 번호를 사람에게 타이핑시키지 않으려면**
 * 이게 있어야 한다 — 화면이 보여주지 않는 번호를 적으라고 하면 그 기능은 없는 것과 같다.
 */
export const ApprovalListQuerySchema = z.object({
  case_id: z.coerce.number().int().positive(),
});
export type ApprovalListQuery = z.infer<typeof ApprovalListQuerySchema>;

export const ApprovalListResponseSchema = z.object({
  items: z.array(ApprovalSchema),
});
export type ApprovalListResponse = z.infer<typeof ApprovalListResponseSchema>;
